<template>
  <fragment>
    <div class="affix fixed" @click="handleClick" :style="affixPosOption">
      <img :src="affixInfo.iconUrl" alt />
    </div>
    <Cmask v-show="show">
      <div class="container" @click="close('dialog')" :style="dialogBgStyle">
        <div v-if="jumpType==7" class="content">
          <div :style="fontStyle" v-html="formatText"></div>
        </div>
        <div class="line" v-if="[5,7].includes(jumpType)">
          <span v-for="item in 5" :key="item"></span>
          <img class="guanbi" src="./../../../assets/imgs/close.png" @click.stop="close('close')" alt />
        </div>
      </div>
    </Cmask>
  </fragment>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
export default {
  name: "Affix",
  props: {
    info: {
      type: Object,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
  },
  inject: ['getEnterSource'],
  computed: {
    enterSource() {
      return this.getEnterSource();
    },
    // 判断是左悬浮或右悬浮
    affixPosOption() {
      return this.position == "right" ? "right: 0px" : "left:0px";
    },
    // 判断dialog背景图片和显示大小
    dialogBgStyle() {
      let bgStyle = {}
      if ([5, 7].includes(this.jumpType)) {
        bgStyle = {
          padding: "50px 31px 37px",
          width: "309px",
          top: "50px",
          height: "390px",
          backgroundImage: `url(${this.jumpType == 5 ? this.affixInfo.dialogUrl : this.affixInfo.boderBgc})`
        }
      } else if (this.jumpType == 6) {
        bgStyle = {
          width: "100vw",
          height: "418px",
          backgroundImage: `url(${this.affixInfo.topDialogUrl})`
        }
      }
      return bgStyle
    },
    // 文字\n 换成<br />
    formatText() {
      return this.affixInfo.text.replace(/\n/g, '<br />')
    },
    fontStyle() {
      return {
        'font-size': this.affixInfo.fontSize / 2 + 'px',
        'color': this.affixInfo.color,
        "font-style": this.affixInfo.fontFontStyle.includes("italic")
          ? "italic"
          : "",
        "font-weight": this.affixInfo.fontFontStyle.includes("bold")
          ? "bold"
          : "",
        "text-stroke": `1px ${this.affixInfo.fontBoxShadow}`
      }
    }
  },
  created() { },
  mounted() {
    this.formatData();
  },
  data() {
    return {
      show: false,
      affixInfo: {},
      jumpType: undefined,
      position: ""
    };
  },
  methods: {
    formatData() {
      console.log(this.info)
      this.affixInfo = this.info.props;
      this.jumpType = this.info.props.jumpType;
      this.position = this.info.position;
    },
    close(str) {
      if (str == 'dialog') {
        if (this.jumpType == 6) {
          this.show = false
        } else {
          console.log('无反应')
        }
      } else {
        this.show = false;
      }
      // this.$emit("close", false);
    },
    handleClick() {
      try {
        let pointID = this.position == 'right' ? '12010006' : '12010005' // 悬浮左和悬浮右的打点是不一样的
        this.$log.senLog({
          pointID: pointID,
          eventType: 2,
          businessData: {
            activityType: this.activityType !== undefined ? this.activityType : '',
            activityId: this.activityId || '',
            appSource: isMiniApplets() ? isMiniApplets() : '',
            enterSource: this.enterSource,
          }
        })
      } catch (e) {
        console.log('打点失败', e)
      }
      if ([5, 6, 7].includes(this.jumpType)) {
        this.show = true;
      } else {
        this.$emit("handleAffixClick", this.affixInfo);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.affix {
  width: 138px;
  height: 60px;
  top: 30px;
  z-index: 3;
  overflow: hidden;

  img {
    width: 100%;
  }
}

.container {
  z-index: 1000;
  position: absolute;
  left: 50%;
  background-size: 100% 100% !important;
  box-sizing: border-box;
  transform: translateX(-50%);
  display: flex;

  .content {
    flex: 1;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 10px 20px;

    div {
      word-wrap: break-word;
      word-break: break-all;
    }
  }

  .line {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 90px;
    display: flex;
    flex-direction: column;

    span {
      width: 4px;
      height: 10px;
      margin-top: 7px;
      background: #fff;
    }
  }

  .guanbi {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: -84px;
    left: 50%;
    color: #fff;
    transform: translateX(-50%);
  }
}
</style>
